// intro
import { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";

import WebbDividerSmall from "../webx/webb-divider-sm";
import WebbDividerMedium from "../webx/webb-divider-md";
import WebbLoader from "../webx/webb-loader";
import WebbModuleInfo from "../webx/webb-module-info";
import WebbNoData from "../webx/webb-nodata";
import WebbDividerHead from "../webx/webb-module-head";

import { Row, Col, Space } from 'antd';

// ------ data ------>
const listData = require('../../data/data-comms.json').data


// ------ code ------>


export default function IntroChannelsModule () {

  const asset = {user: ''}

  const [loading, setLoading] = useState(true);
  const history = useHistory();

  const [data, setData] = useState([]);
  const [sort, setSort] = useState([]);

  useEffect( () => {
    if (asset){
      const fetchData = async() => {
        
        setLoading(true);
        
        setData(listData)

        setLoading(false);
      }
      fetchData()
    } else {}
  },[]);


  if (loading) return <WebbLoader/>
  if (!data || data.length===0) 
  return <WebbNoData data='' />

  return (
  <>
    <div className={``} >
      <Row className="" justify="center">
      <Col xs={0} md={2} lg={2}></Col>
        <Col xs={24} md={18}>
          <h3 className="caption-md m-0">IWNS is Avaiable on following Channels</h3>
          <p className="text-lead"></p>
        </Col>
        <Col xs={0} md={2} lg={2}></Col>
      </Row>
    </div>
    
    <div className={``} >
      <Row className="" justify="center">
        <Col xs={0} md={2} lg={2}></Col>
        <Col xs={24} md={18}>
        <Row className="m-0 p-0" justify="start" gutter={{ xs: 6, sm: 6, md: 6, lg: 6 }}>
          {data && data.map((item, i) => (
            <Col className="" xs={{span:12}} sm={{span:6}} md={{span:6}} lg={{span:4}} key={i}>
            
            <div className="">
              <div className="media-square rounded-wd">
                <img className="border-bottom" src={item.avtr} alt={item.text}></img>
              </div>

              <div className="p-2 px-1">
                <h4 className="text-lead m-0">{item.name}</h4>
                <p className="m-0"><i className={`bx bxs-circle text-small text-color-${item.main ? 'success': 'warning'}`}></i> Mainnet</p>
                <p className="m-0"><i className={`bx bxs-circle text-small text-color-${item.test ? 'success': 'warning'}`}></i> Testnet</p>
              </div>
            </div>    

            <WebbDividerSmall />
            </Col>
          ))}
        </Row>
        </Col>
        <Col xs={0} md={2} lg={2}></Col>
      </Row>

    </div>
  </>

  )
}